import {
	FormControl,
	FormGroup,
	FormLabel,
	Stack,
	Switch,
	Typography,
} from "@mui/material";
import {
	type Control,
	Controller,
	type FieldErrors,
	type FieldPath,
	type FieldValues,
	type Path,
	type PathValue,
} from "react-hook-form";

type FormSwitchProps<FormType extends FieldValues> = {
	control: Control<FormType, object>;
	name: FieldPath<FormType>;
	label?: string;
	defaultValue?: PathValue<FormType, Path<FormType>> | undefined;
	errors?: FieldErrors<FormType>;
	disabled?: boolean;
	customOnChange?: (value: boolean) => void;
};

const FormSwitch = <FormType extends FieldValues>({
	control,
	name,
	label,
	defaultValue,
	customOnChange,
	disabled,
}: FormSwitchProps<FormType>) => {
	return (
		<FormGroup>
			<Stack flexDirection="row" alignItems="center" gap={1}>
				{label && (
					<FormLabel>
						<Typography variant="body2">{label}</Typography>
					</FormLabel>
				)}
				<FormControl>
					<Controller
						name={name}
						control={control}
						defaultValue={defaultValue}
						render={({ field }) => (
							<Switch
								{...field}
								checked={field.value}
								disabled={disabled}
								onChange={(e) => {
									field.onChange(e.target.checked);
									customOnChange?.(e.target.checked);
								}}
								size="small"
							/>
						)}
					/>
				</FormControl>
			</Stack>
		</FormGroup>
	);
};

export default FormSwitch;
